export const ranges = [
  ["0", "24999"],
  ["25000", "99999"],
  ["100000", "499999"],
  ["500000", "999999"],
  ["1000000", "1000000000"],
];

export const getMinOrMaxAsRangeValue = (
  prefix: string,
  value: string | number,
) => {
  const found = ranges.find((arr) => arr.includes(`${value}`));

  return found
    ? JSON.stringify({
        [`${prefix}_min`]: found[0],
        [`${prefix}_max`]: found[1],
      })
    : undefined;
};

export const getRangesAsOptions = (prefix: string) =>
  ranges.map(([min, max], i) => (
    <option key={`${min}-${max}`} value={getMinOrMaxAsRangeValue(prefix, min)}>
      {i === ranges.length - 1
        ? `$${Number(min).toLocaleString()}+`
        : `$${Number(min).toLocaleString()} - $${Number(max).toLocaleString()}`}
    </option>
  ));

export const getRangesAsOptionsArray = (prefix: string) =>
  ranges.map(([min, max], i) => ({
    value: getMinOrMaxAsRangeValue(prefix, min),
    label:
      i === ranges.length - 1
        ? `$${Number(min).toLocaleString()}+`
        : `$${Number(min).toLocaleString()} - $${Number(max).toLocaleString()}`,
  }));
